import styled from "styled-components";
import {DText} from "../../../styles/MarketStyles";
import Text from "../../../utils/Text";


const NoData = ({ size }) => {

    return (
        <NoDataContainer>
            <img
                src={require("../../../assets/images/noData.png")}
                width={size ? size : '80px'}
                alt=" "
            />
            <DText main fontSize={'ss'} style={{ marginTop: '8px' }}>
                <Text tid={'no-data-found'} />
            </DText>
        </NoDataContainer>
    )
}

const NoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 1px solid ${props => props.theme.color}10;
  align-items: center;
  justify-content: center;
  padding-top: 60px;
`

export default NoData;
